import React from 'react';
import styled from 'styled-components';
import { GIButton } from 'app-components';
import { FormattedMessage } from 'react-intl';
import Table from '../../common/table/Table';
import { ConditionalRendering } from '../../common/conditional-rendering';

const StyledTable = styled(Table)({
    'th, td': {
        alignContent: 'center',
    },
    'th:nth-child(3), td:nth-child(3)': {
        width: '220px',
    },
});

const EligibilityDetails = (props) => {
    const { eligibilityDetails, btnData } = props;

    return (
        <div className="eligibility-details">
            <FormattedMessage id="eligibility_results.details.header" tagName="h3" />
            <StyledTable data={eligibilityDetails.data} columns={eligibilityDetails.columns} />

            <ConditionalRendering isTrue={!!btnData}>
                <GIButton
                    id="eligibilityDetailsGoTo"
                    onClickHandler={btnData.btnCb}
                    addlClassNames="usa-button  gi-button gi-button__primary eligibility_CTA"
                    label={btnData.btnText}
                    data-testid="eligibilityDetailsGoTo-button"
                />
            </ConditionalRendering>
        </div>
    );
};

export default EligibilityDetails;
